import { ReactElement, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { Content } from 'antd/es/layout/layout';
import cs from 'classnames';
import getRoutes from 'routes';

import LanguageSelect from 'components/LanguageSelect/LanguageSelect';
import PasswordStrength from 'components/PasswordStrength';

import { LayoutProps, RouteObject } from 'types/route';

import { ReactComponent as Logo } from 'assets/icons/logo.svg';

import styles from './styles.module.scss';

const AuthLayout = ({ children }: LayoutProps): ReactElement => {
  const { pathname } = useLocation();
  const routes = getRoutes();

  const currentRoute = useMemo(
    () => routes.find((route: RouteObject) => route.path === pathname),
    [pathname, routes]
  );

  return (
    <div className={styles.authContainer}>
      <LanguageSelect className={styles.languageSelect} />
      <div className={styles.decorationContainer}>
        <PasswordStrength className={styles.image} />
      </div>
      <div className={cs(styles.funcContainer, currentRoute?.key)}>
        <Logo className={styles.logo} />
        <Content>{children}</Content>
      </div>
    </div>
  );
};

export default AuthLayout;
